<div class="row pt-0">
    <div class="col-12">
        <ngx-loading [show]="loadingIndicator"></ngx-loading>
        <h5>TMS Component Settings</h5>
        <div class="col-12">
            <div widget class="card border-0 box-shadow text-left">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0"><i class="fa fa fa-user" aria-hidden="true"></i> Roles</h5>
                </div>
                <div class="card-body text-left pt-0 widget-body">
                    <span *ngFor="let role of roles">
                        <button type="button" [ngClass]="(role.name == role_active) ? 'btn btn-sm btn-success pp mb-1' : 'btn btn-sm btn-secondary pp mb-1'" data-container="body" data-trigger="hover"data-toggle="popover" data-placement="bottom" 
                            (click)="selectRole(role)" [disabled]="loadingIndicator2">{{role.name}}
                        </button>&nbsp;
                    </span>
                </div>
            </div>
            
            <!-- END OF ROLE TABLE -->
            <br/>
            <!-- COMPONENTS -->
            <div widget class="card border-0 box-shadow selected-column" *ngIf="!loadingIndicator">
                <ngx-loading [show]="loadingIndicator2"></ngx-loading>
                <div class="card-header transparent border-0 text-muted">
                    <div class="card-body pt-0 widget-body" *ngIf="selected.length > 0">
                        <h5><span class="text-success text-bold">{{this.selected[0].name | uppercase}}</span></h5>
                        <h6>TMS Components
                            &nbsp;&nbsp;<small class="text-warning"><input  class="text-right" id="check_all_components" [checked]="check_all_components" type="checkbox" ngbTooltip="Select All TMS Components" (click)="checkAllComponents(frm_components.get('components')['controls'], $event)">&nbsp;Select All TMS Components</small>
                        </h6>
                        <form [formGroup]="frm_components" (ngSubmit)="onSubmit()">
                            <div formArrayName="components" class="form-inline col-12">
                                <div *ngFor="let component of frm_components.get('components')['controls']; let i=index" [ngClass]="components[i]?.tms_root_module == '' ? 'col-12' : 'col-4'">
                                    <!-- <br *ngIf="components[i]?.tms_root_module == ''"> -->
                                    <hr *ngIf="components[i]?.tms_root_module == ''" size="1" class="text-gray">
                                    <div [formGroupName]="i">
                                        <div class="col-12">
                                            
                                            <div class="form-group col-12">
                                                <input type="checkbox" formControlName="is_enabled" ng-true-value="1" ng-false-value="0" (click)="onComponentCheck(component.controls, $event)"><span *ngIf="components[i]?.tms_root_module != ''" class="text-gray"><small>&nbsp;{{components[i]?.tms_root_module}} - </small></span>&nbsp;{{components[i]?.tms_components_name}}
                                            </div>
                                        </div>
                                        

                                    </div>
                                    
                                </div>

                            </div>
                            <br/>
                            <div class="row-md-12">
                                <button type="submit" class="btn btn-sm btn-success btn-sm mb-1" [disabled]="!frm_components.valid || (!frm_components.dirty && !frm_touched) || spinner">Save Changes</button>
                                &nbsp;<i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
                            </div>
                        </form>
                    </div>    
                    <li *ngIf="!selected.length">No Selected Role</li>
                </div>
                
            </div>
            <!--  END COMPONENTS -->
                            
            
        
        </div>
    </div>
</div>

